import React from 'react'
import { Flex } from '@workwhile/ui'
import { TierTransitions } from './TierTransitions'

export const TierInsightsPanel = () => {
  return (
    <Flex
      flexDirection="row"
      maxHeight="80vh"
      border="1px solid"
      borderRadius="standard"
      borderColor="neutrals.100"
      width="fit-content"
    >
      <TierTransitions />
    </Flex>
  )
}
